import React from 'react';
import { Box } from '@mui/material';

const invoiceStages = [
  { stage: 'submitted', label: 'Submitted', count: 2, color: 'blue' },
  { stage: 'review', label: 'Under Review', count: 2, color: 'purple' },
  { stage: 'approved', label: 'Approved', count: 1, color: 'teal' },
  { stage: 'payment-due', label: 'Payment Due', count: 2, color: 'amber' },
  { stage: 'paid', label: 'Paid', count: 1, color: 'green' },
  { stage: 'rejected', label: 'Rejected', count: 1, color: 'red' },
];

export default function InvoiceStatusCard() {
  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Invoice Status</h3>
        <span className="click-tag">Click tiles to filter</span>
      </div>
      <div id="vendInvoiceStageGrid" className="tile-row" style={{ marginBottom: 16 }}>
        {invoiceStages.map((stage) => (
          <Box
            key={stage.stage}
            className="payable-tile"
            onClick={() => window.vendShowDetail?.('invoice-stage', stage.stage)}
          >
            <p className="kpi-label">{stage.label}</p>
            <p className="kpi-value" style={{ fontSize: '24px' }}>{stage.count}</p>
            <div className="kpi-sub flat">invoices</div>
          </Box>
        ))}
      </div>
    </Box>
  );
}
